import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 5,
    cursor: 'pointer'
  },

  selectedFolder: {
    marginLeft: '0.5rem',
    marginRight: '0.5rem',
    fontSize: theme.size.base,
    color: theme.palette.textAlt
  },

  header: {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: 'minmax(auto, 1fr) auto',
    paddingBottom: '1rem',

    '& svg': {
      cursor: 'pointer'
    }
  },

  headerTitle: {
    color: '#3C425B',
    fontSize: theme.size.lg
  },

  menu: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    border: '1px solid #EAEAEA',
    boxSizing: 'border-box',
    borderRadius: '7px',
    width: '340px',
    boxShadow: '0 20px 30px rgba(0, 0, 0, 0.15)',
    padding: '24px',
    background: 'white'
  },

  search: {
    marginBottom: '24px',
    width: '100%',
    height: '32px'
  },

  items: {
    margin: '0.5rem 0px',
    display: 'grid',
    gridTemplateColumns: 'auto minmax(min-content, 1fr)',
    alignItems: 'center',

    '& label': {
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontSize: theme.size.base,
      color: '#3C425B',
      marginLeft: '0.5rem'
    }
  },

  resultsSection: {
    maxHeight: 300,
    overflowY: 'auto'
  },

  createItem: {
    display: 'flex',
    alignItems: 'center',
    background: '#F0F0F0',
    fontStyle: 'italic'
  },

  createIcon: {
    marginRight: '8px'
  }
}))

export default useStyles
